/**
 * This file is only here because multiple entry-points seem to break this version of parcel
 * The actual main-file is ./main.js
 */

import './hundhausen.scss'
import './main'
